import { cn } from "@/lib/utils";
import FadeUp from "@/components/landing/FadeUp";

export const SectionHeading = ({
    eyebrow,
    title,
    sub,
    align = "left",
    testId,
    light = false,
}) => (
    <div
        className={cn(
            "max-w-3xl",
            align === "center" && "mx-auto text-center"
        )}
    >
        {eyebrow && (
            <FadeUp>
                <p
                    className={cn(
                        "text-xs font-semibold tracking-[0.14em] uppercase",
                        light ? "text-white/60" : "text-brand-blue"
                    )}
                >
                    {eyebrow}
                </p>
            </FadeUp>
        )}
        <FadeUp delay={0.05}>
            <h2
                data-testid={testId}
                className={cn(
                    "mt-3 font-bold text-[32px] leading-[1.15] sm:text-4xl md:text-[44px] text-balance",
                    light ? "text-white" : "text-hire-ink"
                )}
            >
                {title}
            </h2>
        </FadeUp>
        {sub && (
            <FadeUp delay={0.1}>
                <p
                    className={cn(
                        "mt-5 text-base md:text-lg leading-relaxed text-pretty",
                        light ? "text-white/70" : "text-hire-muted"
                    )}
                >
                    {sub}
                </p>
            </FadeUp>
        )}
    </div>
);

export const PrimaryButton = ({ className, children, ...props }) => (
    <button
        type="button"
        {...props}
        className={cn(
            "inline-flex items-center justify-center gap-2 h-12 px-6 rounded-xl bg-brand-blue text-white text-sm font-semibold",
            "shadow-[0_8px_24px_-10px_rgba(45,91,255,0.6)] transition-[background-color,transform,box-shadow] duration-200",
            "hover:bg-brand-blue-dark hover:-translate-y-[1px] active:translate-y-0",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2",
            "disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0",
            className
        )}
    >
        {children}
    </button>
);

export const SecondaryButton = ({ className, children, ...props }) => (
    <button
        type="button"
        {...props}
        className={cn(
            "inline-flex items-center justify-center gap-2 h-12 px-6 rounded-xl bg-white text-hire-ink text-sm font-semibold border border-hire-line",
            "transition-[border-color,background-color,transform] duration-200 hover:border-hire-ink/40 hover:bg-hire-bg hover:-translate-y-[1px]",
            "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-blue focus-visible:ring-offset-2",
            className
        )}
    >
        {children}
    </button>
);

export const Card = ({ className, children, ...props }) => (
    <div
        {...props}
        className={cn(
            "rounded-2xl border border-hire-line bg-white transition-[box-shadow,border-color,transform] duration-300",
            className
        )}
    >
        {children}
    </div>
);
